<template>
  <v-layout row>
    <v-flex xs12>
    <v-toolbar app>
    <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
    <v-toolbar-title>Pre-Alertas</v-toolbar-title>
    <v-spacer></v-spacer>
     <v-btn icon to="/prealert"> 
              <v-icon>cancel</v-icon> 
            </v-btn>
  </v-toolbar>
        
        
          <div class="pt-4 pb-4 pl-4 pr-4">
            <v-card class="login-form">
              <v-card-text class="pb-0">
                <v-form v-model="valid">
                  <h2 class="headline mb-3">Crear Prealarta</h2> 
                  
                  <v-text-field solo required :rules="required" v-model="text4" label="Numero Tracking" type="text"></v-text-field>
                  <v-text-field solo required :rules="required" v-model="text5" label="Contenido" type="text"></v-text-field>
                  <v-text-field solo required :rules="required" v-model="text6" label="Valor de la factura US$" type="text"></v-text-field>
                  <v-text-field solo required :rules="required" v-model="text7" label="Suplidor" type="text"></v-text-field>
                 
                  
                  
                </v-form>
              </v-card-text>
              <v-card-actions> 
                <v-btn :disabled="!valid" block color="primary" @click="validateLogin">Guardar</v-btn>
              </v-card-actions>
              
            </v-card>
          </div>
          
        </v-flex>
  </v-layout>
</template>

<script>
  import Helpers from '../utils/helpers'
  import Server from '../utils/server'
export default {

  data () {
    return {
      clipped: false,
      currentUser: undefined,
      noData:false,
      loading: false,
      valid:false,required: [
        v => !!v || 'El campo es requerido'
      ]
    }
  },
  computed: {
    user(){
      return this.$store.getters.user;
    },
    login(){
      return this.$store.getters.login;
    }
  },
   mounted () {
     console.log(Server); 
    if(this.currentUser != undefined){  
    }else if(this.user.userName != null ){
      this.currentUser = this.user;
    }
    
  },
  methods: {
    validateLogin: function () {
        

        var formData = new FormData()
         formData.append('text1', this.currentUser.userName) 
         formData.append('text3', this.currentUser.pushId)
         formData.append('device', window.MobileApi.device)
         formData.append('text4txt', this.text4)
         formData.append('text5txt', this.text5)
         formData.append('text6txt', this.text6)
         formData.append('text7txt', this.text7)

         console.log(Server.createPrealerta); 
        Helpers.getJson(Server.createPrealerta, 'POST', formData, (json) => {
          
        })
        this.$router.push('prealert')
      }
  },
  name: 'App'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
